module.exports = new __parcel__URL__("development-preview-dark.d26e9f57.svg").toString();